module.exports = __webpack_public_path__ + "fd6581375cf33d73fb9d71e0855a90c2.svg";